import { useSound } from '../../hooks/audio/useSound';
import { Volume2, VolumeX } from 'lucide-react';

interface SoundToggleProps {
  compact?: boolean;
}

export const SoundToggle: React.FC<SoundToggleProps> = ({ compact = false }) => {
  const { isSoundEnabled, setSoundEnabled, playUI } = useSound();

  const handleToggle = () => {
    const nextState = !isSoundEnabled;
    void setSoundEnabled(nextState);
    if (nextState) {
      playUI('nav', 'click');
    }
  };

  return (
    <button
      type="button"
      onClick={handleToggle}
      className={
        compact
          ? 'inline-flex h-8 w-8 items-center justify-center rounded-full text-black/55 transition-colors duration-200 hover:text-black focus:outline-none focus-visible:ring-2 focus-visible:ring-black/35 focus-visible:ring-offset-2 focus-visible:ring-offset-[#f7f7f7]'
          : 'inline-flex items-center gap-1.5 pb-0.5 text-sm text-black/65 transition-colors duration-300 hover:text-black focus:outline-none focus-visible:ring-2 focus-visible:ring-black/35 focus-visible:ring-offset-2 focus-visible:ring-offset-[#f7f7f7]'
      }
      aria-pressed={isSoundEnabled}
      aria-label={isSoundEnabled ? 'Disable sound' : 'Enable sound'}
    >
      {isSoundEnabled ? (
        <Volume2 size={16} strokeWidth={1.8} className="opacity-75" />
      ) : (
        <VolumeX size={16} strokeWidth={1.8} className="opacity-75" />
      )}
      {!compact && (
        <span className="label tracking-[0.12em]">{isSoundEnabled ? 'Sound' : 'Muted'}</span>
      )}
    </button>
  );
};
